// Customizable Area Start
import React from "react";
import {
  Box,
  styled,
  IconButton,
  FormControlLabel,
  TextField,
  InputLabel,
  Radio,
  Button,
  MenuItem,
  Collapse,
  TextareaAutosize,
  withStyles,
  Tooltip,
  CircularProgress,
  Typography,
} from "@material-ui/core";
import { colors } from "../../../blocks/utilities/src/Colors";
import {
  DeleteProductIcon,
  IconCalender,
  cartEmptyImage,
  checked,
  contractActive,
  customerAddIcon,
  customerViewIcon,
} from "./assets";
import {
  InputField,
  MultiSelectionBox,
  CustomMenuItem,
  CustomFormControl,
} from "../../../components/src/customComponents/CustomTags.web";
import { Autocomplete } from "@material-ui/lab";
import { ExpandLess, ExpandMore, HelpOutlined } from "@material-ui/icons";
import RemoveIcon from "@material-ui/icons/Remove";
import AddIcon from "@material-ui/icons/Add";
import { StyledRadio } from "../../../components/src/customComponents/RadioDropdown.web";
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from "@material-ui/pickers";
import DateFnsUtils from "@date-io/moment";
import QuickDrop from "../../../blocks/OrderCreation/src/QuickDrop.web";
import StoreCartController, {
  B2bCustomer,
  Props,
  configJSON,
} from "./StoreCartController.web";
import AddCustomerModal from "../../../blocks/email-account-registration/src/AddCustomerModal.web";
import B2BAddCustomerModal from "../../../blocks/customform/src/B2BAddCustomerModal.web";
import { CustomSnackbar } from "../../../components/src/customComponents/CustomSnackbar.web";
import ShowCustomerDetailsModal from "../../../blocks/email-account-registration/src/ShowCustomerDetailsModal.web";
import GoldenPointPaymentModal from "../../../blocks/GoldenPointPayments/src/GoldenPointPaymentModal.web";
import {
  ICustomer,
  IOrder,
  ORDER_TYPES,
} from "../../../blocks/AljabrStore/src/AljabrStore2Controller.web";
import CustomSwitch from "../../../components/src/CustomSwitch.web";
import {
  CustomerDataType,
  IChargeListItem,
  OrderItemPreferences,
  PreferemcesItem,
  Specifications,
  UniqueCombination,
} from "../../../components/src/Interface";
import OrderSummary from "../../../blocks/AljabrStore/src/OrderSummary.web";
import CustomLoader from "../../../components/src/customComponents/CustomLoader.web";
// Customizable Area Start
const ITEM_HEIGHT = 80;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 200,
    },
  },
  anchorOrigin: {
    vertical: "bottom",
    horizontal: "left",
  },
  transformOrigin: {
    vertical: "top",
    horizontal: "left",
  },
  getContentAnchorEl: null,
};
// Customizable Area End

export default class StoreCart extends StoreCartController {
  constructor(props: Props) {
    super(props);
    // Customizable Area Start
    // Customizable Area End
  }

  // Customizable Area Start
  renderCustomerSearch() {
    const {
      countryCodeInput,
      customerPhoneNumber,
      customerList,
      isCountryCodeDisabled,
    } = this.state;
    return (
      <Box className='search-customer-wrap'>
        <InputField
          variant='outlined'
          value={countryCodeInput}
          className='countryInputDigit'
          disabled={isCountryCodeDisabled}
          inputProps={{
            "data-test-id": "field-country-code",
          }}
          onChange={(event: React.ChangeEvent<{ value: string }>) =>
            this.handleChangeCountryCode(event.target.value)
          }
        />
        <StyledAutoComplete
          data-test-id='field-customer-phone'
          noOptionsText={configJSON.noCustomerFound}
          value={customerPhoneNumber}
          options={customerList.map((item: { option: string }) => item.option)}
          onChange={(_event, value) =>
            !value && this.handleOnChangeCustomerPhone()
          }
          onInputChange={(_event, value: string) =>
            this.handleCustomerPhoneNumber(value)
          }
          renderOption={(option) => {
            return (
              <StyledOption>
                <FormControlLabel
                  control={<Radio checked={customerPhoneNumber == option} />}
                  label={<StyleLable>{option as string}</StyleLable>}
                />
              </StyledOption>
            );
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              fullWidth
              variant='outlined'
              placeholder={configJSON.mobileNumber}
              InputProps={{
                ...params.InputProps,
                type: "search",
              }}
            />
          )}
        />
      </Box>
    );
  }

  renderAddCustomerModel() {
    const {
      isB2bActive,
      openAddCustomerModal,
      customerData,
      isEditCustomerForm,
    } = this.state;

    if (isB2bActive) {
      return (
        <B2BAddCustomerModal
          id={"B2BAddCustomerModal"}
          data-test-id='b2b-add-customer-modal'
          navigation={this.props.navigation}
          open={openAddCustomerModal}
          handleClose={() => this.handleCloseAddCustomerPopup()}
          handleGetCustomerPhone={(phone: unknown) =>
            this.onSetCustomerFromPopup(phone)
          }
          customerData={customerData as CustomerDataType}
          isEdit={isEditCustomerForm}
          priceId={"35"}
        />
      );
    } else {
      return (
        <AddCustomerModal
          id={"AddCustomerModal"}
          data-test-id='add-customer-modal'
          navigation={this.props.navigation}
          open={openAddCustomerModal}
          handleClose={() => this.handleCloseAddCustomerPopup()}
          handleGetCustomerPhone={(phone: string) =>
            this.onSetCustomerFromPopup(phone as unknown)
          }
          customerData={customerData}
          isEdit={isEditCustomerForm}
          priceId={"35"}
        />
      );
    }
  }

  returnErrorSnackBar() {
    const { errorSnackbarOpen, errorMessage } = this.state;
    return (
      <CustomSnackbar
        data-test-id='custom-errror-snackbar'
        open={errorSnackbarOpen}
        onClose={() => this.handleSnackbarClose()}
        errorMessage={errorMessage}
        autoHideDuration={3000}
        severity='error'
        hideIcon={true}
      />
    );
  }

  returnCustomerViewPopup() {
    const { viewCustomerPopup, customerData } = this.state;
    return (
      <ShowCustomerDetailsModal
        data-test-id='view-customer-modal'
        navigation={this.props.navigation}
        id={"ShowCustomerDetailsModal"}
        open={viewCustomerPopup}
        handleClose={() => this.handleCloseViewCustomerPopup()}
        customerData={customerData}
        isB2bActive={this.state.isB2bActive}
        handleIsEdit={() => this.handleEditCustomerForm()}
      />
    );
  }



  getPaymentModal() {
    const {
      order,
      customerData,
      isQuickDropOrder,
      isQuickDropCount,
      paymentClicked,
      paymentModalVisible,
    } = this.state;
    const isStoreOrder = this.props.selectedMainTab == ORDER_TYPES.STORE_ORDER;
    let totalItems = 0;
    if (isQuickDropOrder) {
      totalItems = isQuickDropCount;
    } else {
      totalItems = order?.no_of_items || 0;
    }
    return (
      <GoldenPointPaymentModal
        totalItems={totalItems}
        isMainPayment={true}
        open={paymentModalVisible}
        data-test-id='paymentmodal'
        cleaningOrder={!isStoreOrder}
        paymentClicked={paymentClicked}
        customerId={
          this.state.editId ? this.state.customerId : String(customerData?.id)
        }
        onPaymentDone={this.handlePaymentDone}
        handleClose={this.handlePaymentModalClose}
        taxPercentage={this.formatTaxPercentage()}
        order={order as unknown as IOrder}
        onPromoCodeApply={() => this.getLoundryOrder()}
        fromUnpaid={this.state.editId ? true : false}
      />
    );
  }

  getSpecifications = (orderItemPreference: OrderItemPreferences[]) => {
    const result: { [key: string]: Array<string> } = {};

    orderItemPreference.forEach((item) => {
      if (item.attributes.specifications) {
        Object.entries(item.attributes.specifications).forEach(
          ([objKey, objVal]) => {
            if (!result[objKey]) {
              result[objKey] = [];
            }
            if (!result[objKey].includes(objVal)) {
              result[objKey].push(objVal);
            }
          }
        );
      }
    });

    return result;
  };

  getUpcharges = (orderItemPreference: OrderItemPreferences[]) => {
    const output: Array<IChargeListItem & { upchargeCount: number }> = [];
    const upcharges = orderItemPreference.flatMap(
      (item) => item.attributes.upcharges
    );

    upcharges.forEach((upcharge) => {
      const existingUpcharge = output.find(
        (item) => item.attributes.id === upcharge.attributes.id
      );
      if (existingUpcharge) {
        existingUpcharge.upchargeCount++;
      } else {
        output.push({ ...upcharge, upchargeCount: 1 });
      }
    });

    return output;
  };

  showPreferencesData = (
    orderItemPreference: OrderItemPreferences[],
    preference_id: number
  ) => {
    const uniqueNames = Array.from(
      orderItemPreference
        .reduce((mapVal, objVal) => {
          if (objVal.attributes.preference !== null) {
            if (
              !mapVal.has(
                objVal.attributes.preference.attributes.preference_first_name
              )
            ) {
              mapVal.set(
                objVal.attributes.preference.attributes.preference_first_name,
                objVal
              );
            }
          }
          return mapVal;
        }, new Map())
        .values()
    );

    const filterEditedPreferences = uniqueNames.filter(
      (item: OrderItemPreferences) =>
        item.attributes.preference.attributes.id !== preference_id
    );

    const allPreferencesName = filterEditedPreferences.map(
      (item: OrderItemPreferences) =>
        item.attributes.preference.attributes.preference_first_name
    );

    return (
      <div className='specification-data-show'>
        <span>{allPreferencesName.join(" / ")}</span>
      </div>
    );
  };

  showAllUpchargesInCart = (orderItemPreference: OrderItemPreferences[]) => {
    const upcharges_list = this.getUpcharges(orderItemPreference);

    return (
      <ShowAllUpcharges>
        {upcharges_list.map((item, itemIndex) => {
          return (
            <div className='d-flex'>
              <div className='d-flex'>
                <span>{item.attributes.name}</span>
                {item.attributes.name_translation && (
                  <>
                    <span className='circle' />
                    <span className='mr-6'>
                      {item.attributes.name_translation}
                    </span>
                  </>
                )}
              </div>
              <span
                data-test-id={`${configJSON.upchargePriceTest}_${itemIndex}`}
              >
                {" "}
                : SAR {item.attributes.order_price} x {item.upchargeCount}
              </span>
            </div>
          );
        })}
      </ShowAllUpcharges>
    );
  };

  showSQMData(height: string, width: string, weight: string) {
    return (
      <>
        {Number(height) !== 0 && Number(width) !== 0 && (
          <div className='upcharge d-flex'>
            <div>length * width: </div>
            <div>
              {height} m * {width} m
            </div>
          </div>
        )}
        {Number(weight) !== 0 && (
          <div className='upcharge'>weight : {weight} Kg</div>
        )}
      </>
    );
  }

  shoppingCartLoader() {
    return (
      <Box
        style={{
          position: "absolute",
          top: "-16px",
          left: "-16px",
          right: "-16px",
          bottom: "-16px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          zIndex: 1000,
        }}
      >
        <CircularProgress style={{ width: 26, height: 26, color: "#204B9C" }} />
      </Box>
    );
  }

  renderedCartData() {
    const { order, isShoppingcartLoading } = this.state;
    const orders: any[] = Array.isArray(order) ? order : order ? [order] : [];
    if (orders.length === 0) {
      return (
        <Box className='empty-cart-wrapper'>
          <img src={cartEmptyImage} alt='empty-cart-image' />
          <p>{configJSON.Strings.cart_empty_text}</p>
        </Box>
      );
    }
    const inCartOrders = orders.filter(
      (o: any) => o.status === "in_cart" || !o.status
    );
    const allItems = orders.reduce((acc: any[], o: any) => {
      if (o.items?.data && Array.isArray(o.items.data)) {
        acc.push(...o.items.data);
      } else if (o.items && Array.isArray(o.items)) {
        acc.push(...o.items);
      }
      return acc;
    }, []);

    const goldenPoints = allItems
      .map((item: any) => {
        const gp = item?.attributes?.golden_point?.attributes;
        if (!gp) return null;
        return {
          ...gp,
          order_item_id: Number(item.id),
          catalogue_id: Number(item.attributes.golden_point.id),
          quantity: item?.attributes?.quantity ?? 1,
          is_free_item: gp.is_free_item ?? false,
          final_price:
            gp.final_price ?? item?.attributes?.total_final_price ?? 0,
          end_date_base: gp.end_date_base ?? "N/A",
        };
      })
      .filter(Boolean)
      .filter((gp: any) => (gp.quantity ?? 1) > 0);

    if (goldenPoints.length === 0) {
      return (
        <Box className='empty-cart-wrapper'>
          {isShoppingcartLoading && this.shoppingCartLoader()}
          <img src={cartEmptyImage} alt='empty-cart-image' />
          <p>{configJSON.Strings.cart_empty_text}</p>
        </Box>
      );
    }
    const combinedGoldenPoints = goldenPoints.reduce((acc: any[], gp: any) => {
      const existingIndex = acc.findIndex((p) => p.id === gp.id);
      if (existingIndex !== -1) {
        acc[existingIndex] = { ...gp };
      } else {
        acc.push({ ...gp });
      }
      return acc;
    }, []);
    return (
      <Box style={{ position: "relative" }}>
        {isShoppingcartLoading && this.shoppingCartLoader()}
        <Box className='cart-center-top'>
          <p>Order Details</p>
        </Box>
        {/* A driver's order cannot be emptied — the request would have nothing billed. */}
        {!this.isMobileRequestOrder() && (
          <Box className='text-right'>
            <Box
              className='clearAllBtn'
              data-test-id='clear-all-btn'
              onClick={() => this.handleSendAction("CLEAR_CART")}
            >
              {configJSON.clearAllText}
            </Box>
          </Box>
        )}
        {combinedGoldenPoints.map((gp: any, index: number) => (
          <div key={gp.id || index} className='product-total-items'>
            <div className='product-sub-items'>
              <div className='item-grid'>
                {/* Item Name & Info */}
                <div className='flex-1'>
                  <div className='item-name'>
                    <div className='d-flex mr-6'>
                      <p
                        style={{
                          color:
                            !this.state.isB2bActive && gp.is_free_item
                              ? "#059669"
                              : "inherit",
                        }}
                      >
                        <strong>{gp.name}</strong>
                      </p>
                    </div>
                    <div className='item-info'>
                      <p>
                        {`Price: ${gp.final_price && gp.quantity ? (gp.final_price * gp.quantity).toFixed(2) : "N/A" }`}
                      </p>

                      {/* <p>{`Price: ${gp.final_price * gp.quantity?? "N/A"}`}</p> */}
                      <p>{`Points: ${
                        gp.total_points ?? "N/A"
                      } (incl. Bonus)`}</p>
                      <p>{`Free Wash: ${gp.free_wash_quentity ?? "N/A"}`}</p>
                      <p>{`Valid Till: ${gp.end_date_base ?? "N/A"}`}</p>
                    </div>
                  </div>
                </div>

                {/* Item Actions */}
                <div>
                  <div className='total-wrapper'>
                    <div className='total top-space'>
                      {!this.state.isB2bActive
                        ? `SAR: ${
                            gp.final_price && gp.quantity
                              ? (gp.final_price * gp.quantity).toFixed(2)
                              : "N/A"
                          }`
                        : null}
                    </div>
                    {/* <IconButton className='delete top-space'>
                      <img
                        src={DeleteProductIcon}
                        className='deleteIcon'
                        onClick={() =>
                          this.handleSendAction("DELETE_CART_PRODUCT", gp)
                        }
                      />
                    </IconButton> */}
                  </div>
                  <div className='pcs'>
                    {!(!this.state.isB2bActive && gp.is_free_item) && (
                      <IconButton
                        onClick={() => this.cartQtyHandler(gp, "MINUS")}
                      >
                        <RemoveIcon />
                      </IconButton>
                    )}
                    <input
                      className='qty-input'
                      value={gp.quantity ?? 1}
                      onChange={(event) => this.handleInputQty(event, gp)}
                    />
                    {!(!this.state.isB2bActive && gp.is_free_item) && (
                      <IconButton
                        onClick={() => this.cartQtyHandler(gp, "PLUS")}
                      >
                        <AddIcon />
                      </IconButton>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </Box>
    );
  }

  renderSubtotalCollapse() {
    const { cartTotalOpen, order } = this.state;
    if (
      !order ||
      !order.items ||
      !order.items.data ||
      order.items.data.length === 0
    ) {
      return null;
    }
    const itemsInCart = order.items.data.filter(
      (item: any) => (item.attributes.quantity ?? 0) > 0
    );
    if (itemsInCart.length === 0) return null;

    const totalItems = itemsInCart.reduce(
      (acc: number, item: any) => acc + Number(item.attributes.quantity ?? 0),
      0
    );

    const subtotal = itemsInCart.reduce(
      (acc: number, item: any) =>
        acc + Number(item.attributes.unit_price ?? 0),
      0
    );
    const totalVat = itemsInCart.reduce(
      (acc: number, item: any) => acc + Number(item.attributes.total_vat ?? 0),
      0
    );

    const totalFinalPrice = itemsInCart.reduce(
      (acc: number, item: any) =>
        acc + Number(item.attributes.total_final_price ?? 0),
      0
    );

    return (
      <div
        data-test-id='order-summary-total'
        className='order-summary-total'
        onClick={() => this.handleToggleCartTotal()}
      >
        <Collapse in={cartTotalOpen} timeout='auto' unmountOnExit>
          <div className='total-item'>
            <div>Total Items</div>
            <div>{totalItems}</div>
          </div>
          <div className='total-item'>
            <div>Subtotal</div>
            <div>SAR {subtotal.toFixed(2)}</div>
          </div>
          <div className='total-item'>
            <div>Tax ({totalVat.toFixed(2)})</div>
            <div>SAR {totalVat.toFixed(2)}</div>
          </div>
          <div>
            <hr />
          </div>
        </Collapse>
        <div className='total-item total' data-test-id='btn-total'>
          <div>Total</div>
          <div className='flex total' style={{ gap: 8, paddingBottom: 0 }}>
            <div>SAR {totalFinalPrice.toFixed(2)}</div>
            <div className='caret-icon'>
              {cartTotalOpen ? <ExpandMore /> : <ExpandLess />}
            </div>
          </div>
        </div>
      </div>
    );
  }

  renderOrderSummary() {
    const { placedOrder, isQuickDropOrder, customerData } = this.state;
    return (
      <OrderSummary
        data-test-id='order-summary'
        order={placedOrder as unknown as IOrder}
        customer={customerData as unknown as ICustomer}
        onNewOrder={() => this.handleOrderSummaryNewOrder()}
        onClose={() => this.handleClearOrder()}
        isQuickDrop={isQuickDropOrder}
        // onPrint={() => this.handlePrintInvoiceFromOrderSummary()}
      />
    );
  }

  renderMobileRequestBanner() {
    const { order } = this.state;
    const request = order?.mobile_service_request;
    const editable = request?.store_can_edit_orders !== false;
    return (
      <Box
        data-test-id='mobile-request-banner'
        style={{
          margin: "10px 0",
          padding: "10px 12px",
          borderRadius: "8px",
          fontFamily: "Montserrat",
          fontSize: "13px",
          lineHeight: "18px",
          border: `1px solid ${editable ? "#BFDBFE" : "#FECACA"}`,
          backgroundColor: editable ? "#EFF6FF" : "#FEF2F2",
          color: editable ? "#1E40AF" : "#991B1B",
        }}
      >
        <strong>
          Editing driver order{request?.request_number ? ` for ${request.request_number}` : ""}
          {order?.customer?.full_name ? ` · ${order.customer.full_name}` : ""}
        </strong>
        <div>
          {editable
            ? "Changes save as you make them. The driver sees the updated items and sends them to the customer for approval."
            : "The customer is reviewing this order, or has already approved it, so the store can no longer change it."}
        </div>
      </Box>
    );
  }

  renderNotesAndSaveForFuture() {
    const { order } = this.state;
    return (
      <>
        {Number(order?.order_items?.length) > 0 && (
          <Box className='notes-text-wrap'>
            <StyledTextArea
              data-test-id='orde-notes-textarea'
              minRows={1}
              placeholder='Add Note'
              value={this.state.notesTextArea}
              onChange={(event: React.ChangeEvent<{ value: string }>) =>
                this.handleOnChangeNotes(event)
              }
            />
            <Box className='toggle-switch-wrap'>
              <label>Save</label>
              <StyledCustomSwitch
                data-test-id='field-status-switch'
                checked={this.state.saveForFuture}
                onChange={(checked) => this.handleOnCheckedToggle(checked)}
              />
            </Box>
          </Box>
        )}
      </>
    );
  }

  renderCheckContractAvailablity = () => {
    const isContractLinked = this.state.customerData?.id ? true : false;
    return (
      <>
        {this.state.isB2bActive && this.state.customerData?.id && (
          <Box className='bussines-contract'>
            <Box
              style={{
                border: isContractLinked
                  ? "1px solid #059669"
                  : "1px solid #DC2626",
              }}
              className='bussines-contract-info'
            >
              <Typography className='bussines-contract-lable'>
                {(this.state.customerData as B2bCustomer)?.attributes?.name}
              </Typography>
              <Typography className='bussines-contract-lable'>
                <img
                  src={checked}
                  className='bussines-contract-checkmark-image'
                />
                {isContractLinked ? "Linked" : "UnLinked"}
              </Typography>
            </Box>
          </Box>
        )}
      </>
    );
  };

  // Customizable Area End

  render() {
    // Customizable Area Start
    const {
      openAddCustomerModal,
      errorSnackbarOpen,
      viewCustomerPopup,
      serviceDropdownList,
      selectedServiceValue,
      orderSummaryVisible,
      paymentModalVisible,
    } = this.state;
    const isMobileRequestOrder = this.isMobileRequestOrder();
    // Customizable Area End
    return (
      // Customizable Area Start
      <>
        <CustomLoader loading={this.state.isLoading} />
        <CartContainer>
          <Box data-test-id={configJSON.shoppingCartTest}>
            {isMobileRequestOrder && this.renderMobileRequestBanner()}
            {/* The customer is fixed by the request, so there is nothing to search or swap. */}
            {!isMobileRequestOrder && (
            <CartTopSearch>
              <Box className='button-container'>
                {this.renderCustomerSearch()}
                <Button className='customerButton'>
                  <img
                    src={customerAddIcon}
                    className='cursor-pointer'
                    alt='customer add icon'
                    data-test-id='btn-add-customer'
                    onClick={() => this.handleOpenAddCustomerPopup()}
                  />
                </Button>
                <Button className='customerButton'>
                  <img
                    src={customerViewIcon}
                    className='cursor-pointer'
                    alt='customer view icon'
                    data-test-id='btn-view-customer'
                    onClick={() => this.handleViewCustomerPopupOpen()}
                  />
                </Button>
              </Box>
            </CartTopSearch>
            )}
            {this.state.isB2bActive &&
              this.state.customerData?.id &&
              this.renderCheckContractAvailablity()}
            <CartCenterBox>{this.renderedCartData()}</CartCenterBox>
            <CartServicePickup
              style={{ display: this.state.isB2bActive ? "block" : "none" }}
            >
              {!this.state.isB2bActive && (
                <Box>
                  <CustomFormControl variant='outlined' className='formControl'>
                    <SelectionBoxUpdate
                      className='service-dropdown'
                      data-test-id='service-dropdown'
                      labelId={"serviceDropdown"}
                      id={"service-dropdown"}
                      name={"service-dropdown"}
                      fullWidth
                      displayEmpty
                      defaultValue={""}
                      inputProps={{ disableUnderline: true }}
                      MenuProps={MenuProps}
                      value={selectedServiceValue}
                      onChange={(
                        event: React.ChangeEvent<{
                          value: string;
                        }>
                      ) => this.handleServiceDropdown(event)}
                    >
                      <MenuItem
                        style={{ color: colors().darkliver, display: "none" }}
                        value=''
                      >
                        {configJSON.Strings.select_service}
                      </MenuItem>
                      {serviceDropdownList.map((option) => {
                        return (
                          <CustomMenuItem value={option.value}>
                            <FormControlLabel
                              checked={selectedServiceValue === option.value}
                              control={<StyledRadio />}
                              label={""}
                              name='option'
                            />
                            {option.option}
                          </CustomMenuItem>
                        );
                      })}
                    </SelectionBoxUpdate>
                  </CustomFormControl>
                </Box>
              )}
            </CartServicePickup>
            {!isMobileRequestOrder && !orderSummaryVisible && this.renderNotesAndSaveForFuture()}
            {!isMobileRequestOrder && orderSummaryVisible && this.renderOrderSummary()}
            <CartBottomBox>
              {!this.state.isB2bActive && this.renderSubtotalCollapse()}
              {/* {this.renderAddPromotionsButton()} */}
            </CartBottomBox>
          </Box>
          <Box data-test-id='boxGridTest'>
            <CartBottomBox>
              {/* <QuickDrop
                disabled={this.isQuickDropDisabled()}
                count={this.state.isQuickDropCount}
                onCountChange={this.handleQuickDropChange}
                handleChangeQty={(event) =>
                  this.handleChangeQuickInputQty(event)
                }
              /> */}
              <UpdateMainButton
                disabled={this.getPayButtonEnable()}
                data-test-id='btnPay'
                onClick={() => this.handlePayButton()}
                className='fullWidth'
              >
                {this.getPayButtonText()}
              </UpdateMainButton>
            </CartBottomBox>
          </Box>
        </CartContainer>
        {openAddCustomerModal && this.renderAddCustomerModel()}
        {viewCustomerPopup && this.returnCustomerViewPopup()}
        {errorSnackbarOpen && this.returnErrorSnackBar()}
        {paymentModalVisible && this.getPaymentModal()}
      </>
      // Customizable Area End
    );
  }
}

// Customizable Area Start
const CartContainer = styled(Box)({
  maxWidth: "480px",
  width: "100%",
  padding: "15px",
  border: `1px solid ${colors().lightborder}`,
  borderRadius: "8px",
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between",
  overflowY: "auto",
  overflowX: "hidden",
  "& .notes-text-wrap": {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    margin: "12px 0 0 0",
  },
  "& .toggle-switch-wrap": {
    display: "flex",
    gap: "8px",
  },
  "@media only screen and (max-width: 1280px)": {
    maxWidth: "360px",
  },
  "@media only screen and (max-width: 1024px)": {
    maxWidth: "320px",
  },

  "& .bussines-contract": {
    display: "flex",
    flexDirection: "column",
    gap: "8px",
    marginTop: "8px",
  },
  "& .bussines-contract-info": {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    border: "1px solid #059669",
    padding: "8px",
    borderRadius: "8px",
    height: "44px",
  },
  "& .bussines-contract-lable": {
    fontSize: "16px",
    fontWeight: 500,
    display: "flex",
  },
  "& .bussines-contract-checkmark-image": {
    height: "24px",
    width: "24px",
  },
  "& .bussines-contract-check-contract-button": {
    textAlign: "center",
    fontSize: "16px",
    fontWeight: 600,
    height: "44px",
    backgroundColor: "#204B9C",
    color: "#FFFFFF",
    textTransform: "capitalize",
    "&.Mui-disabled": {
      backgroundColor: "#F1F5F9",
      color: "#64748B",
    },
  },
});

export const MainButton = styled(Button)({
  background: "#204B9C",
  fontWeight: 700,
  fontSize: "16px",
  lineHeight: "24px",
  color: colors().white,
  height: "50px",
  width: "186px",
  borderRadius: "8px",
  marginRight: 32,
  textTransform: "unset" as const,
  "&.MuiButton-root.Mui-disabled": {
    color: colors().white,
    cursor: "not-allowed",
    opacity: 0.5,
  },
  "&:hover": {
    background: "#204B9C",
    color: colors().white,
  },
  "&.buttonSecondary": {
    backgroundColor: "#F1F5F9",
    color: "#64748B",
  },
  "&.fullWidth": {
    width: "100%",
  },
  "&.mt-24": {
    marginTop: 24,
  },
});

const UpdateMainButton = styled(MainButton)({
  marginTop: "12px",
  height: "44px",
});

const CartTopSearch = styled(Box)({
  display: "flex",
  gap: "6px",
  "& .MuiOutlinedInput-root": {
    width: "100%",
  },
  "& .MuiOutlinedInput-notchedOutline": {
    borderColor: colors().lightborder,
  },
  "& .countryInputDigit": {
    width: "72px",
    "& .MuiOutlinedInput-input": {
      padding: "9px 8px",
    },
    "& input": {
      fontWeight: 500,
    },
    "& .MuiOutlinedInput-root": {
      border: "none",
    },
    "@media only screen and (max-width: 1280px)": {
      width: "64px",
    },
    "@media only screen and (max-width: 1024px)": {
      width: "50px",
    },
  },
  "& .MuiInputBase-input": {
    height: "unset",
  },
  "& .MuiAutocomplete-root, & .MuiTextField-root": {
    paddingTop: 0,
  },
  "& .MuiAutocomplete-root .MuiOutlinedInput-root": {
    minWidth: 175,
    padding: 0,
    paddingRight: 30,
    "& input": {
      fontWeight: 500,
      padding: "9px 8px !important",
    },
  },
  "& .search-customer-wrap": {
    display: "flex",
    gap: "6px",
    width: "100%",
  },
  "& .cursor-pointer": { cursor: "pointer" },
  "& .customerButton": {
    padding: 0,
    backgroundColor: "#204B9C",
    borderRadius: "8px",
    height: "32px !important",
    minWidth: "32px !important",
    "@media only screen and (max-width: 1280px)": {
      height: "25px !important",
      minWidth: "25px !important",
      "& > span > img": {
        width: 16,
      },
    },
    "@media only screen and (max-width: 1024px)": {
      height: "20px !important",
      minWidth: "20px !important",
      "& > span > img": {
        width: 16,
      },
    },
  },
  "& .button-container": {
    display: "flex",
    alignItems: "center",
    gap: "6px",
    width: "100%",
  },
});

const SelectionBoxUpdate = styled(MultiSelectionBox)({
  "&.service-dropdown": {
    height: "44px !important",
  },
  "& .MuiSelect-root": {
    height: "44px !important",
    minHeight: "44px !important",
  },
});

const CartCenterBox = styled(Box)({
  padding: "16px",
  margin: "12px 0",
  borderRadius: "12px",
  boxShadow: "0px 2px 8px 0px #00000014",
  "& .cart-center-top": {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  "& .empty-cart-wrapper": {
    position: "relative",
    padding: "24px 0",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    "& p": {
      fontSize: "16px",
      fontWeight: 500,
      color: colors().silverChalice,
    },
  },
  "& .scrollable-box": {
    maxHeight: "344px",
    overflow: "auto",
  },
  "& .edit-preference-btn": {
    padding: "8px 10px",
    borderRadius: "8px",
    background: "rgba(32, 75, 156, 0.10)",
    color: "#204B9C",
    cursor: "pointer",
    fontSize: "13px",
    fontWeight: 600,
  },
  "& .text-right": {
    textAlign: "right",
  },
  "& .clearAllBtn": {
    color: colors().statusRed,
    borderBottom: `1px solid ${colors().statusRed}`,
    display: "inline-block",
    cursor: "pointer",
    marginTop: "8px 0 !important",
    fontWeight: 500,
    fontSize: "16px",
  },
  "& .product-total-items": {
    fontSize: 14,
  },
  "& .product-sub-items": {
    gap: 8,
    display: "flex",
    flexFlow: "column",
    padding: "12px 0",
    borderBottom: `1px solid ${colors().lightborder}`,
  },
  "& .mt-10": {
    margin: "10px 0",
  },
  "& .total": {
    fontWeight: 500,
    color: colors().viewTextColor,
  },
  "& .pcs": {
    gap: 4,
    display: "flex",
    borderRadius: 8,
    padding: "5px 12px",
    alignItems: "center",
    color: colors().white,
    justifyContent: "center",
    background: colors().orange,
  },
  "& .qty-input": {
    width: "35px",
    background: "transparent",
    outline: "none",
    border: "1px solid transparent",
    textAlign: "center",
    color: colors().white,
  },
  "& .qty-input:focus": {
    border: "1px solid white",
  },
  "& .total-wrapper": {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    margin: "0 0 12px 0",
  },
  "& .item-grid": {
    gap: 8,
    display: "flex",
    flexWrap: "wrap",
    alignItems: "flex-start",
    "& .grow": {
      flexGrow: 1,
    },
    "& .delete": {
      margin: "0 0 0 8px !important",
      border: "none",
      cursor: "pointer",
      backgroundColor: colors().white,
    },
    "& .MuiIconButton-root": {
      margin: 0,
      padding: 0,
      color: colors().white,
    },
    "@media only screen and (max-width: 1024px)": {
      flexDirection: "column",
    },
  },
  "& .upcharge": {
    fontSize: "13px",
    fontWeight: 400,
    color: colors().darkjunglegreen,
    textTransform: "capitalize",
  },
  "& .name": {
    fontWeight: 600,
    color: colors().cyancobaltblue,
    fontSize: "14px",
    lineHeight: "18px",
    marginTop: "8px",
  },
  "& .item-name": {
    display: "flex",
    flexWrap: "wrap",
    flexGrow: 1,
    fontWeight: 500,
    color: colors().darkjunglegreen,
    "& .circle": {
      height: "3px",
      width: "3px",
      background: colors().black,
      borderRadius: "50%",
      margin: "0 6px",
    },
    "& .mx-6": {
      margin: "0 6px",
    },
    "& .mr-6": {
      margin: "0 6px 0 0",
    },
  },
  "& .d-flex": {
    display: "flex",
    alignItems: "center",
  },
  "& .upcharge-name": {
    fontSize: "12px",
  },
  "& .flex-1": {
    flex: "1 1 0",
  },
  "& .specification-data-show": {
    display: "flex",
    alignItems: "center",
    flexWrap: "wrap",
    "& .specification-span-tag": {
      fontSize: "12px",
      fontFamily: "Montserrat",
      color: colors().darkjunglegreen,
    },
    "& .slash-span": {
      margin: "0 4px",
    },
    "& .slash-span:first-child": {
      display: "none",
    },
  },
});

const CartServicePickup = styled(Box)({
  "& .mt-12": {
    margin: "12px 0 0 0",
  },
  "& .InputLabel": {
    fontFamily: "Montserrat",
    fontSize: "16px",
    lineHeight: "20px",
    fontWeight: 600,
    color: colors().charcoal,
    margin: "0 0 4px 0",
    "@media only screen and (max-width: 1024px)": {
      fontSize: "13px",
    },
  },
  "& .formControl": {
    width: "100%",
    border: `1px solid ${colors().lightborder}`,
    borderRadius: "8px",
  },
  "& .grid-date-picker": {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: "16px",
  },
});

const StyledDatePicker = styled(KeyboardDatePicker)({
  width: "100%",
  "& > div": {
    borderRadius: 8,
    border: `1px solid ${colors().lightborder}`,
    boxShadow: `0px 0px 1px ${colors().lightborder}`,
  },
  "& .MuiButtonBase-root": {
    padding: "4px",
  },
  "& input, & .MuiInputBase-input::placeholder": {
    opacity: 1,
    fontSize: 14,
    color: colors().darkliver,
    padding: "12px",
    fontFamily: "Montserrat",
    "@media only screen and (max-width: 1024px)": {
      fontSize: "12px",
      padding: "15px 5px",
    },
  },
  "& .MuiInput-underline::after, & .MuiInput-underline::before, & p": {
    display: "none",
  },
  "@media only screen and (max-width: 1024px)": {
    "& .MuiInputBase-input": {
      fontSize: "12px",
      padding: "15px 5px",
    },
    "& div button": {
      padding: "2px 1px",
    },
  },
});

const StyledAutoComplete = styled(Autocomplete)({
  flexGrow: 1,
  "& .MuiOutlinedInput-root": {
    borderRadius: 8,
    fontSize: 14,
  },
  "& .MuiInputBase-input": {
    fontSize: 14,
    fontFamily: "Montserrat",
  },
});

const StyledOption = styled(Box)({
  "& > img": {
    mr: 2,
    flexShrink: 0,
  },
});

const StyleLable = styled("p")({
  fontSize: "1rem",
  fontFamily: "Montserrat",
  fontWeight: 400,
  "@media only screen and (max-width: 1024px)": {
    fontSize: 13,
  },
});

const CartBottomBox = styled(Box)({
  "& .order-summary-total": {
    fontSize: 16,
    marginTop: 8,
    borderRadius: 8,
    padding: "8px 12px",
    color: colors().white,
    backgroundColor: colors().orange,
  },
  "& .total-item": {
    fontSize: 14,
    fontWeight: 600,
    display: "flex",
    alignItems: "center",
    paddingBottom: 8,
    justifyContent: "space-between",
  },
  "& .total-item:last-child": {
    paddingBottom: 0,
  },
  "& hr": {
    marginTop: 8,
    border: "none",
    marginBottom: 16,
    borderBottom: `1px solid ${colors().white}`,
  },
  "& .total": {
    fontSize: "16px",
  },
  "& .flex": {
    display: "flex",
    alignItems: "center",
  },
});

const StyledTextArea = styled(TextareaAutosize)({
  padding: 8,
  width: "100%",
  borderRadius: 8,
  border: `1px solid ${colors().lightborder}`,
  fontSize: "14px",
});

const StyledCustomSwitch = styled(CustomSwitch)({
  width: 36,
  height: 20,
  "& .MuiSwitch-thumb": {
    boxSizing: "border-box",
    width: 16,
    height: 16,
    backgroundColor: "white",
  },
  "& .Mui-checked": {
    transform: "translateX(16px) !important",
  },
});

const ShowPreferenceWrapper = styled("div")({
  "&.specification-data-show": {
    display: "flex",
    alignItems: "center",
    flexWrap: "wrap",
    "& .specification-span-tag": {
      fontSize: "12px",
      fontFamily: "Montserrat",
      color: colors().darkjunglegreen,
      textTransform: "capitalize",
    },
    "& .slash-span": {
      margin: "0 4px",
    },
    "& .slash-span:first-child": {
      display: "none",
    },
  },
});

const ShowAllUpcharges = styled("div")({
  "& span": {
    fontSize: "13px",
    fontWeight: 400,
    color: colors().darkjunglegreen,
    textTransform: "capitalize",
  },
  "& .d-flex": {
    display: "flex",
    alignItems: "center",
    flexWrap: "wrap",
  },
  "& .circle": {
    height: "3px",
    width: "3px",
    background: colors().darkjunglegreen,
    borderRadius: "50%",
    margin: "0 6px",
  },
  "& .mr-6": {
    margin: "0 6px 0 0",
  },
});

export const PreferenceTooltip = withStyles({
  tooltip: {
    color: "black",
    fontSize: "12px",
    backgroundColor: "white",
    width: "320px",
    maxWidth: "320px",
    boxShadow:
      "rgba(0, 0, 0, 0.3) 0px 8px 32px 0px, rgba(0, 0, 0, 0.03) 0px 4px 8px 0px",
  },
  arrow: {
    color: "white",
    boxShadow:
      "rgba(0, 0, 0, 0.3) 0px 8px 32px 0px, rgba(0, 0, 0, 0.03) 0px 4px 8px 0px",
  },
})(Tooltip);
// Customizable Area End
